<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.353 5.365L13.67 4l-.682 1.365-1.365.17 1.139.967-.456 1.592 1.364-.909 1.365.91-.456-1.593 1.138-.967-1.364-.17zM25.726 19.92l-1.138-2.274-1.138 2.274-2.274.285 1.896 1.612-.757 2.653 2.273-1.516 2.274 1.516-.758-2.653L28 20.206l-2.274-.285zM8.44 8.549l-.91-1.82-.91 1.82-1.82.228 1.517 1.288-.606 2.123 1.82-1.213 1.818 1.213-.606-2.123 1.517-1.288-1.82-.228zM4 23.106c0 .729.284 1.414.8 1.93L6.964 27.2c.516.516 1.201.8 1.93.8.729 0 1.414-.284 1.93-.8l15.811-15.81c.516-.516.8-1.201.8-1.93 0-.729-.284-1.414-.8-1.93l-2.164-2.164c-1.032-1.032-2.828-1.032-3.86 0L4.8 21.176a2.71 2.71 0 00-.8 1.93zM22.541 7.294l2.165 2.165-4.894 4.894-2.165-2.165 4.894-4.894z"/></svg>
</template>

<script>
export default {
  name: 'objectsWandOutline'
}
</script>
